import CreateAUM from "./Create/CreateAUM";
import EditAUM from "./Update/UpdateAUM";
import SearchAUM from "./List/SearchAUM";

export default {
  list: SearchAUM,
  create: CreateAUM,
  edit: EditAUM,
};
